<mat-dialog-title class="dialog-header">


  <!-- X button -->
  <button mat-icon-button mat-dialog-close aria-label="Close" (click)="close(false)">
    <mat-icon>close</mat-icon>
  </button>
</mat-dialog-title><mat-dialog-content class="dialog-content">
  <ngx-extended-pdf-viewer
    [src]="pdfSrc"
    useBrowserLocale="true"
    [showBookmarkButton]="false"
    [showSidebarButton]="false"
    [showToolbar]="false"
    (pagesLoaded)="onPagesLoaded($event)"
    (pageChange)="onPageChange($event)">
  </ngx-extended-pdf-viewer>
</mat-dialog-content>

<mat-dialog-actions  class="complete-banner" [class.inactive]="!canComplete" >
  
 <span class="banner-label"> {{ canComplete ? 'DOCUMENT COMPLETED' : 'Read to the last page to enable' }} </span> <button color="primary" (click)="close(true)" [disabled]="!canComplete" mat-raised-button type="button"> Close and Complete </button>
</mat-dialog-actions>
